import { useQuery, registerQuery } from 'data-fetching-client';
import { useCallback } from 'react';
import { getUnreadCount } from '../../../../api/notificationsApi';
export const SIDEBAR_UNREAD_COUNT_QUERY_NAME = 'unreadCount';
export const GET_SIDEBAR_UNREAD_COUNT = registerQuery({
  fieldName: SIDEBAR_UNREAD_COUNT_QUERY_NAME,
  fetcher: getUnreadCount
});
export const useSidebarUnreadCountQuery = ({
  skip
}) => {
  const {
    loading,
    error,
    data,
    client,
    refetch
  } = useQuery(GET_SIDEBAR_UNREAD_COUNT, {
    fetchPolicy: 'cache-first',
    skip,
    variables: {
      sidebarState: 'UNREAD'
    }
  });
  const updateCounterCache = useCallback(change => {
    const result = client.readQuery({
      query: GET_SIDEBAR_UNREAD_COUNT,
      variables: {
        sidebarState: 'UNREAD'
      }
    });
    const unreadCount = result === null || result === void 0 ? void 0 : result.unreadCount;
    if (unreadCount && !unreadCount.hasMore) {
      const newValue = unreadCount.counter + change;
      client.cache.writeQuery({
        query: GET_SIDEBAR_UNREAD_COUNT,
        variables: {
          sidebarState: 'UNREAD'
        },
        data: {
          unreadCount: {
            counter: newValue,
            hasMore: unreadCount.hasMore
          }
        }
      });
    }
  }, [client]);
  return {
    loading,
    error,
    data,
    refetch,
    updateCounterCache
  };
};